var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, SelectEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
export default class MyChartDischargeSummaryCardAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onSelect = new SelectEventListener();
        this.onClick = new ClickEventListener();
        this.onContextMenuClick = new ClickEventListener();
        this.onDoubleClick = new ClickEventListener();
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MyChartDischargeSummaryCardAPI.prototype, "onSelect", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MyChartDischargeSummaryCardAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MyChartDischargeSummaryCardAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MyChartDischargeSummaryCardAPI.prototype, "onDoubleClick", void 0);
//# sourceMappingURL=my-chart-discharge-summary-card-api.js.map